export default __webpack_public_path__ + "static/media/Julianne_Kirkland_AHV_In_Moms_We_Trust.df9d4326.jpg";